// Conversation content for "Experience with working on growth" topic
// Edit this file to update the conversation content

const growthConversation = {
  id: 'growth',
  title: 'Growth & Experiments',
  messages: [
    "I love growth work because it forces a rare kind of clarity: what are we trying to move, and did we actually move it?",
    "",
    "I first caught the bug at Wish, building models to kill leaked promo codes before they torched our margins. It was my first intro to moving metrics by combining systems, code, and UX.",
    "",
    "I brought that 'fix-the-system' mindset to Credit Karma when I built a growth pod from scratch for our main Discovery surface.",
    "",
    "At the time, the redesign was deep in the red on revenue. It was a massive headwind.",
    "",
    "I stood up a high-velocity engine—shipping 90+ experiments across 23 features in a single year.",
    "",
    "By scaling experiment volume 4x, we compounded our impact 6x and turned that negativitity into a sustained positive return.",
    "",
    "That engine ultimately delivered over $200M in incremental impact, driving back-to-back record revenue in FY24, FY25 and FY26, plus the biggest MAU gains since the mobile app first launched.",
    "",
    "My POV: Good growth isn’t just surface-level A/B tests. It’s a high-cadence machine where systems, incentives, and UX all pull in the same direction."
  ]
};

export default growthConversation;





